var oConstantes;

function GetObjConstantes() {
    if (oConstantes == undefined) {
        oConstantes = new ObjConstantes();
    }
    return oConstantes;
}

function ObjConstantes() {
};

ObjConstantes.prototype = {
    LINK_SECTOR: '#LSECTOR&p=1',
    LINK_PAIS: '#LPAISES&p=1',
    LINK_ACTIVIDAD: '#LACTIVIDAD&p=1',
    LINK_PRODUCTO: '#LPRODUCTOS&p=1',
    LINK_REPRESENTADA: '#LREPRESENTADAS&p=1',
    LINK_MARCA: '#LMARCAS&p=1',
    LINK_STAND: '#LSTANDS&p=1',
    _SECTOR: "S",
    _MARCA: "M",
    _STAND: "ST",
    _REPRESENTADA: "R",
    _PAIS: "P",
    _PRODUCTO: "O",
    _GENERICO: "G",
    _ACTIVIDAD: "A",

    //impresion
    _LISTA: "L",
    _FAVORITOS: "F",
    _FICHA: "E",
    _MAPA_FERIA: "MF",
    _MAPA_PABELLON: "PA",
    _NO_IMPRIMIR: "N",
    
    //LINK_SVR: 'http://www.ifema.es:80/planning/web/loginWindow.jsp?codFeriaGC=FT14&idioma=es&codInsercion=78805400&codempsec=1&pagina=solicitud.jsp'

    _MODO_PRUEBA: getQueryVariable('MPRUEBA')

    
}